<template>
  <div class="container">
    <div class="navbar">
      <div class="left-nav">
        <img src="../assets/logo.png" alt="" />
        <button @click="handleLeftClick">Left</button>
      </div>
      <div class="center-nav">
        <button @click="handleCenterClick">
          <img src="../assets/logo.png" alt="" />
        </button>
      </div>
      <div class="right-nav">
        <img src="../assets/logo.png" alt="" />
        <button @click="handleRightClick">Right</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, onBeforeUnmount } from "vue";
import { ElMessage } from "element-plus";

const handleLeftClick = () => {
  ElMessage.info("Left button clicked");
};

const handleCenterClick = () => {
  ElMessage.info("Center button clicked");
};

const handleRightClick = () => {
  ElMessage.info("Right button clicked");
};

onMounted(() => {
  // 初始化逻辑
});

onBeforeUnmount(() => {
  // 清理逻辑
});
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100vh;
  position: relative;
  background: #ccc;
}

.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  z-index: 1000;
  padding: 10px 20px;
  width: 100%;
  height: 100px;
  margin: 0 auto;
}

.navbar::before {
  content: "";
  position: absolute;
  top: -10px;
  left: calc(50% - 55px);
  right: 0;
  width: 110px;
  height: 70px;
  background-color: #ccc;
  border-radius: 12px 12px 60px 60px;
  z-index: -1;
}

.left-nav,
.right-nav {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 30%;
  button {
    background-color: transparent;
    border: none;
    font-size: 16px;
    color: #333;
    cursor: pointer;
  }
  img {
    width: 20px;
    height: 20px;
  }
}

.center-nav {
  position: relative;
  bottom: 40px; /* 提升中心按钮 */
  img {
    width: 40px;
    height: 40px;
  }
  button {
    background-color: #ed50f1;
    border: none;
    border-radius: 50%;
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  }
}
</style>